<template>
  <div>
    <CRow>
      <CCol class="col-12">
        <CCard class="mb-2">
          <CCardBody class="p-2">
            <CRow>
              <CCol xs="12" sm="4" class="mt-sm-0 pr-sm-1">
                <CButton
                  :color="cropButtonColor('tomato')"
                  class="w-100"
                  @click="changeCrop('tomato')"
                >
                  <img
                    :src="app.getUrl('img/crops/tomato.png')"
                    style="width: 18px"
                  />
                  토마토
                </CButton>
              </CCol>
              <CCol xs="12" sm="4" class="mt-1 mt-sm-0 pl-sm-1 pr-sm-1">
                <CButton
                  :color="cropButtonColor('strawberry')"
                  class="w-100"
                  @click="changeCrop('strawberry')"
                >
                  <img
                    :src="app.getUrl('img/crops/strawberry.png')"
                    style="width: 18px"
                  />
                  딸기
                </CButton>
              </CCol>
              <CCol xs="12" sm="4" class="mt-1 mt-sm-0 pl-sm-1">
                <CButton
                  :color="cropButtonColor('paprika')"
                  class="w-100"
                  @click="changeCrop('paprika')"
                >
                  <img
                    :src="app.getUrl('img/crops/capsicum.png')"
                    style="width: 18px"
                  />
                  파프리카
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <DiseaseAnalysisComponent
      :properties="properties"
    ></DiseaseAnalysisComponent>
  </div>
</template>

<script>
import core from "@/core";
import DiseaseService from "@/services/disease/disease.service";
import MixinStorage from "@/mixins/storage";
import EXIF from "exif-js";
import CoreKakaoMap from "@/core/core-kakao-map";
import CodeService from "@/services/code/code.service";
import DiseaseAnalysisComponent from "@/components/analysis/DiseaseAnalysisComponent";
import store from "@/store";

export default {
  name: "Disease",
  components: {
    DiseaseAnalysisComponent,
  },
  mixins: [MixinStorage("disease")],
  data() {
    return {
      app: store.state.app,
      crop: "tomato",
      properties: {
        cropCode: null,
        engine: {
          visible: false,
          versionList: [],
        },
      },
    };
  },
  mounted() {
    this.$nextTick(async () => {
      core.loader.hide();
      await this.storageWait();
      const crop = this.getStorageItems("crop");
      if (crop != null) {
        this.changeCrop(crop);
      } else {
        this.changeCrop(this.crop);
      }
    });
  },
  methods: {
    cropButtonColor(crop) {
      if (this.crop === crop) {
        return "dark";
      } else {
        return "light";
      }
    },
    async changeCrop(crop) {
      this.crop = crop;

      const items = this.getStorageItems();
      if (items.crop !== crop) {
        items.crop = crop;
        this.saveStorageItems();
      }

      if (crop === "strawberry") {
        this.properties.engine = {
          visible: true,
          versionList: [
            { value: "v1", label: "V1" },
            { value: "v2", label: "V2" },
          ],
        };
      } else {
        this.properties.engine = {
          visible: false,
          versionList: [],
        };
      }
      this.properties.cropCode = await CodeService.findCropCodeByEnName(crop);
    },
    clearImage() {
      this.image.status = "";
      this.image.name = "";
      this.image.src = "";
      this.image.clazz = "";
      this.image.item = null;
      this.analysis = null;
    },
    onDrop(event) {
      this.inputImageFile(event.dataTransfer.files);
    },
    onChangeImageFile(e) {
      this.inputImageFile(e.target.files);
    },
    inputImageFile(files) {
      if (files.length) {
        let file = files[0];
        if (!/^image\//.test(file.type)) {
          alert("이미지 파일만 등록이 가능합니다");
          return false;
        }
        this.image.name = file.name;
        this.preview(file);
      } else {
        this.clearImage();
      }
    },
    async preview(file) {
      const image = this.image;

      const item = (image.item = await core.utils.image.getImageBlob(
        file,
        1980,
      ));
      //console.log("image : ", image);
      if (item.width < item.height) {
        image.clazz = "vertical";
      } else {
        image.clazz = "";
      }
      image.src = item.dataUri;
      image.status = "ready";

      function convertGpsDmsToDegree(degrees, minutes, seconds, direction) {
        let dd = degrees + minutes / 60 + seconds / (60 * 60);

        if (direction === "S" || direction === "W") {
          dd = dd * -1;
        } // Don't do anything for N or E
        return dd;
      }

      EXIF.getData(file, function () {
        const allMetaData = EXIF.getAllTags(this);
        //console.log("allMetaData : ", allMetaData);
        const gpaLatitude = allMetaData.GPSLatitude;
        const gpaLongitude = allMetaData.GPSLongitude;
        if (gpaLatitude != null && gpaLongitude != null) {
          const latDegree =
            gpaLatitude[0].numerator / gpaLatitude[0].denominator;
          const latMinute =
            gpaLatitude[1].numerator / gpaLatitude[1].denominator;
          const latSecond =
            gpaLatitude[2].numerator / gpaLatitude[2].denominator;
          const latDirection = allMetaData.GPSLatitudeRef;
          item.latitude = Number(
            convertGpsDmsToDegree(
              latDegree,
              latMinute,
              latSecond,
              latDirection,
            ).toFixed(7),
          );

          const lngDegree =
            gpaLongitude[0].numerator / gpaLongitude[0].denominator;
          const lngMinute =
            gpaLongitude[1].numerator / gpaLongitude[1].denominator;
          const lngSecond =
            gpaLongitude[2].numerator / gpaLongitude[2].denominator;
          const lngDirection = allMetaData.GPSLongitudeRef;
          item.longitude = Number(
            convertGpsDmsToDegree(
              lngDegree,
              lngMinute,
              lngSecond,
              lngDirection,
            ).toFixed(7),
          );
        }
      });
    },
    async onAnalysisRequest() {
      const image = this.image;
      //console.log("image : ", image);
      if (image.item.latitude == null || image.item.longitude == null) {
        //console.log("위치 지정 필요");
        const result = await core.alert.show({
          title: "알림",
          body: "사진 촬영 위치를 선택해주세요",
          showCancelButton: true,
          confirmButtonText: "계속",
        });
        if (result === "confirm") {
          this.modal.searchAddress.visible = true;
        }
        return;
      }
      core.loader.show("병해 영상 분석 중...");
      try {
        const formData = new FormData();
        formData.append("fileObj", image.item.blob, image.item.filename);
        formData.append("latitude", image.item.latitude);
        formData.append("longitude", image.item.longitude);
        if (image.item.address1 == null) {
          // 주소 가져오기
          const kakaoMap = new CoreKakaoMap();
          const result = await kakaoMap.findAddressByLatAndLng(
            image.item.latitude,
            image.item.longitude,
          );
          image.item.address1 = result.address;
          image.item.address2 = result.buildingName;
          if (image.item.address2 == null) image.item.address2 = "";
          //console.log("result : ", result);
        }
        formData.append("address1", image.item.address1);
        formData.append("address2", image.item.address2);

        const cropCode = await CodeService.findCropCodeByEnName(
          this.selectedCrop,
        );
        formData.append("cropCode", cropCode);
        const analysis = await DiseaseService.imageAnalysis(formData);

        image.status = "result";
        this.analysis = analysis;
      } catch (e) {
        console.log(e);
      }

      core.loader.hide();
    },
    getAnalysisInfoUrl(analysisResult) {
      return DiseaseService.getInfoUrl(
        analysisResult.name,
        analysisResult.similarity,
      );
    },
  },
};
</script>
